export const SET_MAILBANNER = "setMailBanner";
